import NotificationDispatcher from "../core/notification-dispatcher/NotificationDispatcher";
import ApiClient from "../infrastructure/api/ApiClient";
import Endpoints from "../infrastructure/api/Endpoint/Endpoints";

const updateOffer = (api: ApiClient, notificationDispatcher: NotificationDispatcher): UpdateOffer => (offerId, fields) => {
    return api.offers_Id.patch(offerId, {
        _command: 'UPDATE',
        ...fields
    })
};
export default updateOffer;

export type UpdateOffer = (offerId: string, fields: UpdatableFields) => Promise<any>;

export type UpdatableFields = Omit<Endpoints.Offers_Id.PatchBody, '_command'>
